import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import TestimonialCard from "../components/TestimonialCard";
import aboutImage from "../assets/images/about.jpg";
import test1Image from "../assets/images/test1.jpg";
import alphaImage from "../assets/images/alpha.jpeg";
import ahmedImage from "../assets/images/ahmed.jpeg";
import eslamImage from "../assets/images/eslam.jpeg";
import emiyImage from "../assets/images/emiy.jpeg";
import mikyImage from "../assets/images/miky.jpg";
import saraImage from "../assets/images/sara.jpeg";
import irImage from "../assets/images/ir.jpg";
import onlineImage from "../assets/images/online.jpeg";
import botImage from "../assets/images/bot.jpg";

const testimonials = [
  {
    name: "Biniam Billiso",
    photo: test1Image,
    position: "Biomedical Engineer",
    quote: "Abate Alemu is a skilled student with a strong background in front-end and back-end technologies.With expertise in HTML, CSS, JavaScript, and modern frameworks such as React and Vue.js, Abate is adept at creating dynamic, user-friendly web applications. Proficient in Node.js and databases like MongoDB, he can build full-stack solutions that are both functional and efficient. ",
  },
  {
    name: "Alpha Lencho",
    position: "ML Engineer |Ethiopian Cursor Ambassador",
    photo: alphaImage,
    quote: "Beyond his technical abilities, Abate is a very proactive and capable student. Abate is adept at creating dynamic, user-friendly web applications. Proficient in Node.js and databases like MongoDB, he can build full-stack solutions that are both functional and efficient.",
  },
  {
    name: "Assistant Professor Dr Workshet Debay",
    photo: ahmedImage,
    position: "Enterprise System Architect",
    quote: "I am confident that Abate Alemu possesses the skills, knowledge, and dedication.Abate is adept at creating dynamic, user-friendly web applications. Proficient in React.js and databases like ORM, he can build full-stack solutions that are both functional and efficient.",
  },
  {
    name: "Eslam Abdelaziz",
    photo: eslamImage,
    position: "Software Engineer",
    quote: "Abate is a diligent and committed student, always willing to go the extra mile Abate is adept at creating dynamic, user-friendly web applications. Proficient in Node.js and databases like MongoDB, he can build full-stack solutions that are both functional and efficient.",
  },
  {
    name: "Nafargi Damena",
    photo: emiyImage,
    position: "UI/UX Designer",
    quote: "I am confident that Abate Alemu possesses the skills, knowledge, and dedicationAbate is adept at creating dynamic, user-friendly web applications. Proficient in Node.js and databases like MongoDB, he can build full-stack solutions that are both functional and efficient.",
  },
  
  {
    name: "Bethel Baynesagn",
    photo: saraImage,
    position: "Frontend Developer",
    quote: "Beyond his technical abilities, Abate is a very proactive and capable student Abate is adept at creating dynamic, user-friendly web applications. Proficient in Node.js and databases like MongoDB, he can build full-stack solutions that are both functional and efficient.",
  },
];

// Hero Projects from Resume
const heroProjects = [
  {
    title: "Online Maintenance Request System",
    description: "Developed an online maintenance request system for Ethiopian Customs Commission. This system streamlines maintenance workflows, improves efficiency, and received recognition for outstanding contribution.",
    image: onlineImage,
    organization: "Ethiopian Customs Commission",
  },
  {
    title: "Enterprise Network Design - 4 Kilo Campus",
    description: "Designed and simulated a full enterprise network for Addis Ababa University's 4 Kilo campus with redundancy using Cisco HSRP. Created comprehensive documentation and presented the network topology to stakeholders.",
    image: irImage,
    organization: "Addis Ababa University",
  },
  {
    title: "AI Enabled Websites for NGOs",
    description: "Designed AI enabled websites for two non-governmental organizations - Tihut Organization and Power Plan Development Program. These solutions leverage AI to enhance user experience and organizational efficiency.",
    image: botImage,
    organization: "Tihut Organization & Power Plan Development Program",
  },
];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 2 >= testimonials.length ? 0 : prevIndex + 2
      );
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 2 >= testimonials.length ? 0 : prevIndex + 2
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 2 < 0 ? testimonials.length - 2 : prevIndex - 2
    );
  };

  return React.createElement(
    motion.div,
    {
      className: "home container",
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: 1 },
      style: styles.homeContainer,
    },
    // Hero Section with Profile Picture
    React.createElement(
      "div",
      { style: styles.heroSection },
      React.createElement(
        motion.div,
        {
          initial: { scale: 0, opacity: 0 },
          animate: { scale: 1, opacity: 1 },
          transition: { duration: 0.8, ease: "easeOut" },
          style: styles.imageWrapper,
        },
        React.createElement("img", {
          src: aboutImage,
          alt: "Abate Alemu",
          style: styles.profileImage,
          className: "profileImage",
        })
      ),
      React.createElement(
        motion.h1,
        {
          initial: { y: -20, opacity: 0 },
          animate: { y: 0, opacity: 1 },
          transition: { duration: 0.8, delay: 0.2, ease: "easeOut" },
          style: styles.welcomeTitle,
        },
        "Welcome to My Portfolio"
      ),
      React.createElement(
        motion.p,
        { 
          initial: { y: 20, opacity: 0 },
          animate: { y: 0, opacity: 1 },
          transition: { duration: 0.8, delay: 0.4, ease: "easeOut" },
          style: styles.welcomeText,
        },
        "Explore my projects and get in touch with me to collaborate!"
      )
    ),
    
    // Hero Projects Section
    React.createElement(
      "div",
      { style: styles.projectsSection },
      React.createElement("h2", { style: styles.sectionTitle }, "Featured Projects"),
      React.createElement(
        "div",
        { style: styles.projectsGrid },
        heroProjects.map((project, index) =>
          React.createElement(
            "div",
            { key: index, style: styles.projectCard },
            React.createElement(
              "div",
              { style: styles.imageContainer },
              React.createElement("img", {
                src: project.image,
                alt: project.title,
                style: styles.projectImage,
              })
            ),
            React.createElement(
              "div",
              { style: styles.projectContent },
              React.createElement("h3", { style: styles.projectTitle }, project.title),
              React.createElement("p", { style: styles.projectOrg }, project.organization),
              React.createElement("p", { style: styles.projectDescription }, project.description)
            )
          )
        )
      )
    ),

    // Testimonials Section
    React.createElement(
      "div",
      { style: styles.testimonialsSection },
      React.createElement("h2", { style: styles.sectionTitle }, "Testimonials"),
      React.createElement(
        "div",
        {
          style: styles.testimonialsContainer,
        },
        React.createElement(
          "button",
          { onClick: handlePrev, style: styles.button },
          "<"
        ),
        React.createElement(
          "div",
          { style: styles.slider },
          testimonials
            .slice(currentIndex, currentIndex + 2)
            .map((testimonial, index) =>
              React.createElement(TestimonialCard, {
                key: index,
                name: testimonial.name,
                photo: testimonial.photo,
                quote: testimonial.quote,
                position: testimonial.position,
              })
            )
        ),
        React.createElement(
          "button",
          { onClick: handleNext, style: styles.button },
          ">"
        )
      )
    )
  );
};

const styles = {
  homeContainer: {
    textAlign: "center",
    padding: "20px",
  },
  heroSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "60px",
    padding: "40px 20px",
  },
  imageWrapper: {
    marginBottom: "30px",
    position: "relative",
  },
  profileImage: {
    width: "220px",
    height: "220px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "5px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3), 0 0 0 10px rgba(0, 119, 182, 0.2)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
  },
  welcomeTitle: {
    color: "white",
    fontSize: "2.5rem",
    marginBottom: "20px",
    textShadow: "2px 2px 8px rgba(0, 0, 0, 0.3)",
  },
  welcomeText: {
    color: "white",
    fontSize: "1.2rem",
    marginBottom: "40px",
    textShadow: "1px 1px 4px rgba(0, 0, 0, 0.3)",
  },
  projectsSection: {
    marginTop: "50px",
    marginBottom: "50px",
  },
  testimonialsSection: {
    marginTop: "50px",
  },
  sectionTitle: {
    color: "white",
    fontSize: "2rem",
    marginBottom: "30px",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
  },
  projectsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "30px",
    marginBottom: "40px",
    maxWidth: "1200px",
    margin: "0 auto 40px",
  },
  projectCard: {
    background: "rgba(255, 255, 255, 0.95)",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    transition: "transform 0.3s ease",
    display: "flex",
    flexDirection: "column",
  },
  imageContainer: {
    width: "100%",
    height: "200px",
    overflow: "hidden",
    background: "#f5f5f5",
  },
  projectImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.3s ease",
  },
  projectContent: {
    padding: "24px",
    flex: "1",
    display: "flex",
    flexDirection: "column",
  },
  projectTitle: {
    fontSize: "1.4rem",
    color: "#0077b6",
    marginBottom: "8px",
    fontWeight: "600",
  },
  projectOrg: {
    fontSize: "0.9rem",
    color: "#666",
    marginBottom: "12px",
    fontStyle: "italic",
  },
  projectDescription: {
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.6",
    flex: "1",
  },
  testimonialsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginTop: "30px",
    flexWrap: "wrap",
    width: "100%",
    padding: "0 10px",
  },
  slider: {
    display: "flex",
    gap: "20px",
    overflow: "hidden",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%",
  },
  button: {
    background: "#0077b6",
    color: "white",
    border: "none",
    borderRadius: "5px",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "1rem",
    transition: "background-color 0.3s ease",
  },
};

export default Home;
